import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsAreasListCreateRoute extends Route {
  @service store;

  model() {
    return this.store.createRecord('area');
  }
}

export default instrumentRoutePerformance(SettingsAreasListCreateRoute);
